import { LazyLoad } from 'app/utils';

export const UserInvitationFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserInvitationFormPage,
);
